import {
  Children,
  cloneElement,
  isValidElement,
  type ReactNode
} from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';

type Props = {
  content?: string | null;
  openLinksInNewTab?: boolean;
};

const isolateLatinText = (children: ReactNode): ReactNode =>
  Children.map(children, child => {
    if (typeof child === 'string') {
      return (
        <span dir="auto">
          {child.split(/([A-Za-z][A-Za-z0-9._:/-]*)/g).map((part, index) =>
            /^[A-Za-z]/.test(part) ? (
              <bdi key={`${part}-${index}`} dir="ltr">
                {part}
              </bdi>
            ) : (
              part
            )
          )}
        </span>
      );
    }

    if (
      isValidElement<{ children?: ReactNode }>(child) &&
      child.props.children
    ) {
      return cloneElement(child, {
        children: isolateLatinText(child.props.children)
      });
    }

    return child;
  });

const MarkdownRenderer = ({ content, openLinksInNewTab = false }: Props) => {
  return (
    <div className="m-0 p-0">
      <ReactMarkdown
        components={{
          p: ({ node: _node, children, ...props }) => (
            <p style={{ margin: 0, padding: 0 }} {...props}>
              {isolateLatinText(children)}
            </p>
          ),
          a: ({ href, children }: { href?: string; children?: ReactNode }) => (
            <Link
              to={href ?? '#'}
              target={openLinksInNewTab ? '_blank' : undefined}
              rel={openLinksInNewTab ? 'noopener noreferrer' : undefined}
            >
              {isolateLatinText(children)}
            </Link>
          )
        }}
      >
        {content ?? ''}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
